import { AbstractDTO } from "@signature-it/ngx-generic/models";

export class PreviousOrderDTO extends AbstractDTO {

    constructor(attributes?: object) {
        attributes = attributes ? attributes : {};
        super(attributes);
    }

}
